import {Injectable, WritableSignal} from "@angular/core";

import * as Models from "app/services/proxy/model/models";
import {FeatureFlagsHelper} from "app/services/third-party/feature-flags/feature-flags-helper.service";

import {Lookup} from "framework/services/utils.service";

// Reads flags report_generation already resolved server-side and injected into window.CS_FEATURE_FLAGS, since the report page's network-isolated browser can't reach LaunchDarkly directly.
@Injectable()
export class InjectedFeatureFlagsProvider
{
    private m_releaseFlagState: WritableSignal<Lookup<Models.ReleaseFlag>> = null;
    private m_featureFlagState: WritableSignal<Lookup<Models.FeatureFlag>> = null;
    private m_applied: boolean                                            = false;

    private applyInjectedFlags(): void
    {
        if (this.m_applied) return;
        this.m_applied = true;

        const injectedFlags = window.CS_FEATURE_FLAGS;
        if (!injectedFlags) return;

        const releaseFlags: Lookup<Models.ReleaseFlag> = {};
        const featureFlags: Lookup<Models.FeatureFlag> = {};

        for (const [flagName, flagValue] of Object.entries(injectedFlags))
        {
            if (FeatureFlagsHelper.isReleaseFlag(flagName))
            {
                releaseFlags[flagName] = FeatureFlagsHelper.createReleaseFlag(Models.FeatureFlagCategory.RELEASE, flagName, flagValue, flagValue);
            }
            else
            {
                featureFlags[flagName] = FeatureFlagsHelper.createFeatureFlag(Models.FeatureFlagCategory.FEATURE, flagName, flagValue, flagValue);
            }
        }

        this.m_releaseFlagState?.set({...this.m_releaseFlagState(), ...releaseFlags});
        this.m_featureFlagState?.set({...this.m_featureFlagState(), ...featureFlags});
    }

    //--// Public API
    public initializeProvider(_context: Models.FeatureFlagContext): void
    {
        this.applyInjectedFlags();
    }

    public setReleaseFlagsState(state: WritableSignal<Lookup<Models.ReleaseFlag>>): void
    {
        this.m_releaseFlagState = state;
    }

    public setFeatureFlagsState(state: WritableSignal<Lookup<Models.FeatureFlag>>): void
    {
        this.m_featureFlagState = state;
    }

    public async queueFlag(_request: Models.FeatureFlagRequestBase): Promise<void>
    {
        this.applyInjectedFlags();
    }

    public async queueFlags(_request: Models.FeatureFlagRequestBase): Promise<void>
    {
        this.applyInjectedFlags();
    }
}
